import { useQueryClient } from '../react-query';
import type { QueryMeta } from '../utils/fetch/types';

export const useGetQueryMeta = () => {
  const queryClient = useQueryClient();
  return queryClient.getDefaultOptions().queries?.meta as QueryMeta;
};
